import React from "react";
import { useParams } from "react-router-dom";
import StartInstructions from "Components/Contest/StartInstructions";
import ContestPage from "Components/Contest/ContestPage";

const Contest = () => {
  const { id, tab } = useParams();

  return (
    <>{!tab || tab == "start" ? <StartInstructions /> : <ContestPage />}</>
  );
};

export default Contest;
